/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useState } from 'react';
import ImageLoader from 'react-render-image';
import { fg } from '@atlaskit/platform-feature-flags';
import { LoadingSkeleton } from '../loading-skeleton';
var styles = {
  roundImg: "_2rko14q2"
};
var ImageIcon = function ImageIcon(_ref) {
  var defaultIcon = _ref.defaultIcon,
    testId = _ref.testId,
    url = _ref.url,
    width = _ref.width,
    height = _ref.height,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'square' : _ref$appearance,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    _ref$hideLoadingSkele = _ref.hideLoadingSkeleton,
    hideLoadingSkeleton = _ref$hideLoadingSkele === void 0 ? false : _ref$hideLoadingSkele;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasImageErrored = _useState2[0],
    setHasImageErrored = _useState2[1];

  // If url changes, reset state
  useEffect(function () {
    setHasImageErrored(false);
  }, [url]);
  if (hasImageErrored) {
    return defaultIcon;
  }
  if (hideLoadingSkeleton && fg('platform_fix_block_card_img_icon_vc')) {
    return /*#__PURE__*/React.createElement("img", {
      src: url,
      "data-testid": "".concat(testId, "-image"),
      alt: "",
      style: {
        width: width,
        height: height
      },
      onError: function onError() {
        return setHasImageErrored(true);
      },
      className: ax([appearance === 'round' && styles.roundImg])
    });
  } else {
    return /*#__PURE__*/React.createElement(ImageLoader, {
      src: url,
      loading: /*#__PURE__*/React.createElement(LoadingSkeleton, {
        testId: "".concat(testId, "-loading"),
        width: width,
        height: height
      }),
      loaded: /*#__PURE__*/React.createElement("img", {
        src: url,
        "data-testid": "".concat(testId, "-image"),
        alt: "",
        style: {
          width: width,
          height: height
        },
        className: ax([appearance === 'round' && styles.roundImg])
      }),
      errored: defaultIcon,
      onError: onError,
      onLoad: onLoad
    });
  }
};
export default ImageIcon;